module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-pag/home-main-pag.component.sass
// module id = ./src/app/modules/home/components/home-main-pag/home-main-pag.component.sass
// module chunks = main